import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { LOGO, BRAND } from "@/lib/config";
import { Phone, Menu, X } from "lucide-react";

export const Navbar = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const scrollTo = (id) => {
    setOpen(false);
    if (window.location.pathname !== "/") {
      navigate("/");
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 300);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/85 border-b border-slate-200/70">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
          <img src={LOGO} alt="BOCO BINS LLC" className="h-14 w-14 rounded-full object-cover ring-2 ring-boco-navy/10" />
          <div className="leading-none hidden sm:block">
            <div className="font-display font-extrabold text-boco-navy text-xl tracking-tight">
              BOCO BINS <span className="text-boco-green">LLC</span>
            </div>
            <div className="text-[10px] tracking-[0.25em] text-slate-500 font-semibold mt-0.5">
              CLEAN. SANITIZE. DEODORIZE.
            </div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-7 text-sm font-semibold text-slate-600">
          <button onClick={() => scrollTo("service-check")} className="hover:text-boco-navy transition-colors" data-testid="nav-service-area">Service Area</button>
          <button onClick={() => scrollTo("pricing")} className="hover:text-boco-navy transition-colors" data-testid="nav-pricing">Pricing</button>
          <button onClick={() => scrollTo("communities")} className="hover:text-boco-navy transition-colors" data-testid="nav-communities">Communities</button>
          <Link to="/pressure-washing" className="hover:text-boco-navy transition-colors" data-testid="nav-pressure-washing">Pressure Washing</Link>
        </nav>

        <div className="flex items-center gap-3">
          <a href={BRAND.phoneHref} className="hidden sm:flex items-center gap-2 text-boco-navy font-bold" data-testid="nav-phone">
            <Phone className="h-4 w-4" /> {BRAND.phone}
          </a>
          <Link
            to="/book"
            className="inline-flex items-center rounded-full bg-boco-green px-4 sm:px-5 py-2.5 text-sm font-bold text-boco-navy hover:bg-boco-greendark hover:text-white transition-colors shadow-sm"
            data-testid="nav-book-btn"
          >
            Book Now
          </Link>
          <button
            onClick={() => setOpen((v) => !v)}
            className="md:hidden inline-flex h-10 w-10 items-center justify-center rounded-full text-boco-navy hover:bg-slate-100 transition-colors"
            aria-label="Toggle menu"
            data-testid="nav-menu-toggle"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden border-t border-slate-200/70 bg-white/95 backdrop-blur-xl" data-testid="mobile-menu">
          <nav className="mx-auto max-w-7xl px-5 py-4 flex flex-col gap-1 text-base font-semibold text-boco-navy">
            <button onClick={() => scrollTo("service-check")} className="text-left py-3 border-b border-slate-100" data-testid="mobile-nav-service-area">Service Area</button>
            <button onClick={() => scrollTo("pricing")} className="text-left py-3 border-b border-slate-100" data-testid="mobile-nav-pricing">Pricing</button>
            <button onClick={() => scrollTo("communities")} className="text-left py-3 border-b border-slate-100" data-testid="mobile-nav-communities">Communities</button>
            <Link to="/pressure-washing" onClick={() => setOpen(false)} className="py-3 border-b border-slate-100" data-testid="mobile-nav-pressure-washing">Pressure Washing</Link>
            <a href={BRAND.phoneHref} className="py-3 flex items-center gap-2 text-boco-greendark" data-testid="mobile-nav-phone"><Phone className="h-4 w-4" /> {BRAND.phone}</a>
          </nav>
        </div>
      )}
    </header>
  );
};
